module.exports = __webpack_public_path__ + "img/freespin_feature.f4e561e7.png";